export { Text, TextFonts, TextSizes, TextWrappers, TextLineHeights } from './text';
export type { TextTheme } from './text';
export type { TextProps } from './text';
export {TextInterface} from './text.interface';